import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { ReadMore as d } from "../ReadMore/index.js";
import { useTranslation as c } from "../../hooks/useTranslation.js";
import o from "./containmentblock.module.js";
const f = ({
  header: t,
  items: i,
  isReadMore: l
}) => {
  const { t: n } = c();
  return /* @__PURE__ */ s("div", { className: o.destyleList, children: [
    /* @__PURE__ */ e("div", { className: o.containmentHeader, children: t[0] }),
    l ? /* @__PURE__ */ e(
      d,
      {
        numberOfLines: 4,
        openText: n("show_everything"),
        closeText: n("hide"),
        fade: !0,
        children: /* @__PURE__ */ e("ul", { children: i.map((r) => /* @__PURE__ */ e("li", { children: r }, r)) })
      }
    ) : /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("ul", { children: i.map((r) => /* @__PURE__ */ e("li", { children: r }, r)) }) })
  ] });
};
export {
  f as ContainmentBlock
};
